export default function ResearchPartnership() {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-[#F5F9F6]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-microscope-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">大学との共同研究</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            筑波大学との<br className="md:hidden" />研究パートナーシップ
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            世界トップレベルの研究機関である筑波大学と連携し、<br className="hidden md:block" />
            最先端の養殖技術を実用化しています。
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://storage.readdy-site.link/project_files/fc18929a-f6b4-4a9e-92ee-da32c9ea052d/f27ec625-f699-4991-8d20-0df56adea607_AFE58916C94D75A508192263661C2A11D0D91FAD.jpg?v=a351198982c2df3e896647aa583c4f5d"
                alt="筑波大学キャンパス"
                className="w-full h-[500px] object-cover object-top"
              />
            </div>

          </div>

          <div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-[#E8F5E9] mb-8">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden mr-6 flex-shrink-0 bg-gradient-to-br from-[#2D7A3E] to-[#4CAF50] flex items-center justify-center">
                  <i className="ri-user-line text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-[#1A2332] mb-2">張振亜 名誉教授</h3>
                  <p className="text-[#2D7A3E] font-semibold mb-3">筑波大学 生命環境系</p>
                  <p className="text-gray-600 leading-relaxed">
                    閉鎖循環型陸上養殖システムの第一人者として、環境に配慮した持続可能な水産生産技術の研究開発に長年従事。本プロジェクトの技術顧問として、システム設計から運用まで全面的に支援。
                  </p>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9]">
                <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-book-open-line text-white text-xl"></i>
                </div>
                <h4 className="text-lg font-bold text-[#1A2332] mb-2">研究実績</h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  30年以上の研究経験と多数の学術論文を発表
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9]">
                <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-global-line text-white text-xl"></i>
                </div>
                <h4 className="text-lg font-bold text-[#1A2332] mb-2">国際的評価</h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  世界各国で技術指導と共同研究を実施
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-white p-10 rounded-2xl shadow-lg border border-[#E8F5E9]">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#2D7A3E] to-[#4CAF50] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-flask-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-[#1A2332] mb-2">技術開発</h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                最先端の養殖技術を共同開発
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#2D7A3E] to-[#4CAF50] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-[#1A2332] mb-2">人材育成</h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                専門技術者の育成プログラム
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#2D7A3E] to-[#4CAF50] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-[#1A2332] mb-2">継続的改善</h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                データ分析による技術向上
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}